import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { Check, X, Building2, Globe, FileBadge } from "lucide-react";

export default function AdminApprovals() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState({});

  const load = async () => {
    try {
      const r = await api.get("/admin/pending-approvals");
      setPending(r.data);
    } catch { toast.error("Errore caricamento"); }
  };
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    setLoading(s => ({ ...s, [id]: "approve" }));
    try {
      await api.post(`/admin/users/${id}/approve`);
      toast.success("Buyer B2B approvato");
      await load();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    finally { setLoading(s => ({ ...s, [id]: null })); }
  };

  const reject = async (id) => {
    setLoading(s => ({ ...s, [id]: "reject" }));
    try {
      await api.post(`/admin/users/${id}/reject`);
      toast.success("Richiesta rifiutata");
      await load();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
    finally { setLoading(s => ({ ...s, [id]: null })); }
  };

  return (
    <div data-testid="admin-approvals-page">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold">Verifica B2B</div>
          <h1 className="editorial-heading text-4xl mt-1">Approvazioni in attesa</h1>
          <p className="text-sm text-muted-foreground mt-1">Verifica manualmente operatori B2B (broker, importatori, Ho.Re.Ca., GDO) prima di sbloccare prezzi pallet e preventivi.</p>
        </div>
        <div className="chip bg-[hsl(var(--accent))]/20 text-[hsl(var(--accent))]">{pending.length} in attesa</div>
      </div>

      <div className="mt-8 space-y-4">
        {pending.length === 0 && (
          <div data-testid="approvals-empty" className="bg-card border border-border rounded-sm p-10 text-center text-muted-foreground">
            Nessuna richiesta in attesa di verifica.
          </div>
        )}
        {pending.map(u => (
          <div key={u.id} data-testid={`approval-${u.id}`} className="bg-card border border-border rounded-sm p-5">
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">Contatto</div>
                <div className="font-semibold text-lg editorial-heading mt-1">{u.name}</div>
                <div className="text-sm text-muted-foreground">{u.email}</div>
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5" />Azienda</div>
                <div className="font-semibold mt-1">{u.company || "—"}</div>
                <div className="text-xs text-muted-foreground flex items-center gap-1.5 mt-1"><FileBadge className="h-3.5 w-3.5" />VAT: {u.vat_number || "—"}</div>
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-1.5"><Globe className="h-3.5 w-3.5" />Paese</div>
                <div className="font-semibold mt-1">{u.country || "—"}</div>
                <div className="text-xs text-muted-foreground mt-1">Richiesto {new Date(u.created_at).toLocaleDateString()}</div>
              </div>
            </div>
            <div className="mt-5 pt-4 border-t border-border flex flex-wrap gap-2 justify-end">
              <Button
                data-testid={`approve-btn-${u.id}`}
                size="sm"
                onClick={() => approve(u.id)}
                disabled={!!loading[u.id]}
                className="bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm gap-1.5"
              >
                <Check className="h-4 w-4" />{loading[u.id] === "approve" ? "Approvando…" : "Approva"}
              </Button>
              <Button
                data-testid={`reject-btn-${u.id}`}
                size="sm"
                variant="outline"
                onClick={() => reject(u.id)}
                disabled={!!loading[u.id]}
                className="rounded-sm gap-1.5 border-destructive text-destructive hover:bg-destructive hover:text-white"
              >
                <X className="h-4 w-4" />{loading[u.id] === "reject" ? "…" : "Rifiuta"}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
